import React from 'react';
import { ArrowRight } from 'lucide-react';
export const CallToAction = () => {
  return <section className="relative py-20 w-full overflow-hidden" data-id="element-30">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[#0B0C10] z-0" data-id="element-31">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?q=80&w=3270&auto=format&fit=crop')] opacity-10 bg-cover bg-center" data-id="element-32"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-transparent to-[#0B0C10]" data-id="element-33"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="bg-gradient-to-r from-[#00E5FF]/10 to-[#B721FF]/10 backdrop-blur-sm border border-[#F5F5F5]/10 rounded-2xl p-8 md:p-12 shadow-xl shadow-[#00E5FF]/5" data-id="element-35">
          <div className="text-center" data-id="element-36">
            <h2 className="text-3xl md:text-4xl font-bold font-['Orbitron'] mb-6 leading-tight" data-id="element-37">
              Your idea deserves to be more than a thought.
              <span className="block bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-38">
                Let's make it a reality.
              </span>
            </h2>
            <p className="text-lg text-[#F5F5F5]/80 mb-8 max-w-2xl mx-auto" data-id="element-39">
              Share your vision with us, and we'll transform it into a
              successful digital product that exceeds your expectations.
            </p>
            <button className="px-8 py-4 bg-gradient-to-r from-[#00E5FF] to-[#B721FF] rounded-xl text-[#0B0C10] font-bold text-lg shadow-lg shadow-[#00E5FF]/20 hover:shadow-xl hover:shadow-[#00E5FF]/30 transition-all duration-300 flex items-center gap-2 mx-auto" data-id="element-40">
              Get Started Now
              <ArrowRight size={20} data-id="element-41" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};